import { configureStore } from '@reduxjs/toolkit';
import combineReducer from '../Rootreducer'

const store = configureStore({ reducer: combineReducer });


export default store;